export default "__VITE_ASSET__BoO0RBX7__"